<div class="terms-page f-p">
  <div class="row">
    <div class="col-12 terms-page-bg">
      <div class="container-xl">
        <h2>Terms & Conditions</h2>
        <div class="white-bg">
          <p>
            Welcome to Kunnect, LLC (“Kunnect,” “we,” “us,” or “our”). By
            accessing or using our website (“Website”), you agree to be bound by
            these Terms & Conditions. If you do not agree with these terms,
            please discontinue use immediately.
          </p>
          <h6>1. Use of This Website</h6>
          <p>
            Kunnect provides this Website and its content for informational
            purposes. While we strive for accuracy, all content is provided “as
            is” without warranties of any kind. Your use of this Website is at
            your own risk, and Kunnect assumes no liability for any inaccuracies
            or reliance placed on the information provided.
          </p>
          <h6>2. Access & Service Limitations</h6>
          <ul>
            <li>
              Certain areas of this Website may require registration or a
              subscription fee to access specific content, downloads, or
              services.
            </li>
            <li>
              Kunnect may provide limited clarification of its content via email
              at [insert contact email], but any additional services, advice, or
              professional engagement require a separate commercial agreement.
            </li>
            <li>
              We reserve the right to modify, suspend, or discontinue any part
              of this Website without prior notice.
            </li>
          </ul>
          <h6>3. Intellectual Property Rights</h6>
          <ul>
            <li>
              All content, designs, trademarks, and intellectual property on
              this Website are owned by or licensed to Kunnect.
            </li>
            <li>
              You may not copy, reproduce, modify, distribute, republish,
              display, or transmit any content without prior written consent
              from Kunnect.
            </li>
            <li>
              You may view or print individual pages for personal use only.
            </li>
          </ul>
          <p>
            All other brand names, product names, and trademarks appearing on
            this Website belong to their respective owners.
          </p>
          <h6>4. External Links & Third-Party Content</h6>
          <ul>
            <li>
              This Website may contain links to third-party websites or
              resources. Kunnect does not control or endorse these external
              sites and is not responsible for their availability, content, or
              services.
            </li>
            <li>
              Any reliance on third-party content is at your own risk, and we
              encourage you to review their respective terms and privacy
              policies.
            </li>
          </ul>
          <h6 class="mt-4">5. Data Protection & Privacy</h6>
          <p class="lh-normal">
            Kunnect respects your privacy. Any personal data you provide is
            handled in accordance with our Privacy Policy.
          </p>
          <ul>
            <li>
              Information you provide may be used to process registrations, and
              subscriptions, and enhance user experience.
            </li>
            <li>
              We take reasonable steps to protect user data, but we do not
              guarantee the absolute security of electronic communications.
            </li>
            <li>
              For full details on how we collect, use, and safeguard your data,
              please review our Privacy Policy [Insert Link].
            </li>
          </ul>
          <h6 class="mt-4">6. Disclaimer & Limitation of Liability</h6>
          <ul>
            <li>
              No Guarantees: Kunnect provides this Website and its content
              without warranties, express or implied, including but not limited
              to merchantability, fitness for a particular purpose, and
              non-infringement.
            </li>
            <li>
              No Responsibility for Errors: While we strive to update our
              content regularly, Kunnect does not guarantee that all information
              is current, accurate, or complete.
            </li>
            <li>
              User Assumes Risk: Your use of this Website is entirely at your
              own risk. We are not responsible for any losses, damages, or
              consequences arising from reliance on its content.
            </li>
            <li>
              Indirect Damages: Kunnect will not be liable for any indirect,
              incidental, consequential, or punitive damages, including loss of
              data, revenue, or profits, arising from the use of this Website.
            </li>
          </ul>
          <h6 class="mt-4">7. Availability & Technical Issues</h6>
          <ul>
            <li>
              This Website is provided on an “as available” basis, and we do not
              guarantee uninterrupted or error-free access.
            </li>
            <li>
              Kunnect is not liable for service interruptions due to technical
              issues, maintenance, or factors beyond our control.
            </li>
          </ul>
          <h6 class="mt-4">8. Changes to Terms & Website</h6>
          <ul>
            <li>
              Kunnect may update these Terms & Conditions at any time, and
              changes will be effective immediately upon posting.
            </li>
            <li>
              Continued use of this Website after modifications constitutes your
              acceptance of the updated Terms.
            </li>
          </ul>
          <h6 class="mt-4">9. Governing Law & Jurisdiction</h6>
          <ul>
            <li>
              These Terms & Conditions are governed by the laws of the State of
              Texas, without regard to conflict of law principles.
            </li>
            <li>
              Any disputes arising from these Terms or your use of this Website
              shall be resolved exclusively in the state or federal courts
              located in Texas.
            </li>
            <li>
              If you access this Website from outside the U.S., you are
              responsible for compliance with your local laws.
            </li>
          </ul>
        </div>
      </div>
    </div>
    <app-book-consultation [title]="title" class="spa0 col-12" />
  </div>
</div>
